module.exports = __webpack_public_path__ + "static/media/majorB6.f27a84b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB6.wav
// module id = OXkW
// module chunks = 0